import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  GetProductPricePoliciesFromGGSheet,
  ImportProductPricePoliciesFromExcel,
  ImportProductPricePoliciesFromGGSheet,
  ProductPricePolicyApi,
  RawProductPricePoliciesType,
} from 'api';

export const findProductPricePolicyForTableList = createAsyncThunk(
  'productPricePolicy/findProductPricePolicyForTableList',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findProductPricePolicy = createAsyncThunk(
  'productPricePolicy/findProductPricePolicy',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createProductPricePolicy = createAsyncThunk(
  'productPricePolicy/createProductPricePolicy',
  async (body: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneProductPricePolicy = createAsyncThunk(
  'productPricePolicy/findOneProductPricePolicy',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await ProductPricePolicyApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateProductPricePolicy = createAsyncThunk(
  'productPricePolicy/updateProductPricePolicy',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await ProductPricePolicyApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createMultiProductPricePolicy = createAsyncThunk(
  'productPricePolicy/createMultiProductPricePolicy',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.createMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateMultiProductPricePolicy = createAsyncThunk(
  'productPricePolicy/updateMultiProductPricePolicy',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.updateMulti(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeProductPricePolicy = createAsyncThunk(
  'productPricePolicy/removeProductPricePolicy',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.remove(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const removeMultiProductPricePolicy = createAsyncThunk(
  'productPricePolicy/removeMultiProductPricePolicy',
  async (body: { productPricePolicyIDs: string[] }, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.removeMulti(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const getProductPricePolicyFromGGSheet = createAsyncThunk(
  'productPricePolicy/getProductPricePolicyFromGGSheet',
  async (query: GetProductPricePoliciesFromGGSheet, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.getDataFromGGSheet(query);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const getProductPricePolicyFromExcel = createAsyncThunk(
  'productPricePolicy/getProductPricePolicyFromExcel',
  async (
    body: {
      rawProducts: RawProductPricePoliciesType[];
      pricePolicyID?: string;
      importMethod?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await ProductPricePolicyApi.getDataFromExcel(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const importProductPricePolicyFromGGSheet = createAsyncThunk(
  'productPricePolicy/importProductPricePolicyFromGGSheet',
  async (body: ImportProductPricePoliciesFromGGSheet, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.importDataFromGGSheet(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const importProductPricePolicyFromExcel = createAsyncThunk(
  'productPricePolicy/importProductPricePolicyFromExcel',
  async (body: ImportProductPricePoliciesFromExcel, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.importDataFromExcel(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const getSheetsFromGGSheet = createAsyncThunk(
  'productPricePolicy/getSheetsFromGGSheet',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await ProductPricePolicyApi.getSheetsFromGGSheet(id);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  tableList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: IState = {
  tableList: [],
  list: [],
  reloadFlag: false,
};

const productPricePolicySlice = createSlice({
  name: 'productPricePolicy',
  initialState,
  reducers: {
    reloadProductPricePolicy(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        findProductPricePolicyForTableList.fulfilled,
        (state, action) => {
          const { data } = action.payload;
          const newData = data.map(item => {
            return {
              ...item,
              key: item.id,
              value: item.id,
            };
          });

          state.tableList = newData;
        }
      )
      .addCase(findProductPricePolicy.fulfilled, (state, action) => {
        const { data } = action.payload;

        const newData = data.map(item => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;
      });
  },
});

const { actions, reducer: productPricePolicyReducer } = productPricePolicySlice;

export const { reloadProductPricePolicy } = actions;

export default productPricePolicyReducer;
